const parseSectionData = (state, payload) => {
  payload.forEach((section) => {
    state.sections[section.section_name] = section;
  });
};

const applySettings = (state, payload) => {
  state.showPrices = payload.showPrices;
  state.hasAvailabilty = payload.hasAvailabilty;
  state.hasScaleModel = payload.hasScaleModel;
  state.assetsUrl = payload.assetsUrl;
};

export default {
  parseSectionData,
  applySettings
};



// WEBPACK FOOTER //
// ./src/store/modules/project/mutations.js